module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), ((_vm.isUserE106 || _vm.isUserShpo) && !_vm.isUserShpoCrApproving) ? _c('div', [_c('e106Compliances', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), (!(_vm.isUserClg || _vm.isUserE106 || _vm.isUserShpoCrApproving || _vm.isClientUser)) ? _c('div', [_c('fieldworkRequests', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), (!(_vm.isUserClg || _vm.isUserE106 || _vm.isUserShpoCrApproving || _vm.isClientUser)) ? _c('div', [_c('fileSearches', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isUserClg && !_vm.isUserE106) ? _c('div', [_c('investigations', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isUserShpo || _vm.isUserBlm) && !_vm.isUserShpoCrApproving) ? _c('div', [_c('undertakings', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUserBlm) ? _c('div', [_c('moasPas', {
    attrs: {
      "type": "todo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canViewRadioCarbon) ? _c('div', [_c('labResults', {
    attrs: {
      "type": "todo"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.isUserClg || _vm.isUserShpo) && !_vm.isUserShpoCrApproving) ? _c('div', [_c('buildingSurveys', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUserClg || _vm.isUserShpo) ? _c('div', [_c('buildingReconForms', {
    attrs: {
      "type": "todo",
      "isUserRc": _vm.isUserShpoRc
    }
  })], 1) : _vm._e(), _vm._v(" "), (!(_vm.isUserClg || _vm.isUserE106 || _vm.isUserShpoCrApproving || _vm.isClientUser)) ? _c('div', [_c('siteNumberRequests', {
    attrs: {
      "type": "todo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUserShpo && !_vm.isUserShpoCrApproving) ? _c('div', [_c('mediaNotification')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Dashboard")]), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b91c627e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 988
// module chunks = 1